<template>
  <div class="container-fluid">
    <!-- Bread-crumb-->
    <div class="block-header">
      <bread-crumb :breadCrumbIteams="breadCrumbIteams"></bread-crumb>
    </div>

    <!-- Country Info Card -->
    <div class="row clearfix">
      <div class="col-12">
        <div class="card country-info-card">
          <div class="card-body">
            <div class="country-header">
              <div class="country-flag-wrapper">
                <span :class="countryFlagClass"></span>
          </div>
              <div class="country-details">
                <h3 class="country-name">{{ countryName }}</h3>
                <div class="country-meta">
                  <span class="meta-item">
                    <strong>Code:</strong> {{ countryCode }}
                                    </span>
                  <span class="meta-item">
                    <strong>Currency:</strong> {{ currencyCode }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                          </div>
                        </div>

    <!-- Payout Options Card -->
    <div class="row clearfix">
      <div class="col-12">
        <div class="card">
          <div class="header">
            <h2>Payout Options</h2>
            <small class="text-muted">Configure payout methods available for this country</small>
                          </div>
          <div class="body">
            <form @submit.prevent="savePayoutOptions">
              <PayoutOptions
                ref="payoutOptions"
                :countryId="countryId"
                @save-success="handlePayoutSaveSuccess"
                @save-error="handlePayoutSaveError"
              />

              <!-- Action Buttons -->
              <div class="action-buttons">
                <button type="button" class="btn btn-secondary" @click="cancel()">
                            Cancel
                </button>
                <template v-if="$store.getters['authpermission/hasAnyPermission'](['country.edit'])">
                  <button type="submit" class="btn btn-primary" :disabled="saving">
                    <span v-if="saving">
                      <i class="fa fa-spinner fa-spin"></i> Saving...
                    </span>
                    <span v-else>Save Changes</span>
                  </button>
                </template>
              </div>
            </form>
        </div>
      </div>
    </div>
  </div>
    
    <main-loader ref="loader"></main-loader>
  </div>
</template>

<script>
import BreadCrumb from "@/components/BreadCrumb";
import PayoutOptions from "./options/PayoutOptions.vue";
const LoaderComponent = require("@/components/admin/loader/LoaderComponent.vue").default;
import shared from "@/shared.js";

export default {
  name: "CountryDetailComponent",
  components: {
    BreadCrumb,
    PayoutOptions,
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      countryId: "",
      countryName: "",
      countryCode: "",
      currencyCode: "",
      countryFlagClass: "",
      saving: false,
      breadCrumbIteams: [],
    };
  },
  methods: {
    async savePayoutOptions() {
      if (this.$refs.payoutOptions) {
        this.saving = true;
        try {
          await this.$refs.payoutOptions.savePayoutOptions();
        } finally {
          this.saving = false;
        }
      }
    },

    handlePayoutSaveSuccess(message) {
      shared.toastrSuccess(message || "Payout options saved successfully");
    },

    handlePayoutSaveError(message) {
      shared.toastrError(message || "Error saving payout options");
    },

    cancel() {
      this.$router.push({ path: "/country/list" });
    },

    loadCountryDetail() {
      // Load country details from localStorage (set by ListComponent)
      this.countryName = localStorage.getItem("countryName") || "Unknown Country";
      this.countryCode = localStorage.getItem("countryCode") || "";
      this.currencyCode = localStorage.getItem("countryCurrency") || "GHS";
      
      if (this.countryCode) {
        this.countryFlagClass = `flag-icon flag-icon-${this.countryCode.toLowerCase()} flag-icon-squared`;
      }
      
      this.breadCrumbIteams = [
        { title: "Country", links: "/country/list" },
        { title: this.countryName, links: "" },
      ];
    },
  },
  mounted() {
    if (localStorage.getItem("countryId")) {
      this.countryId = localStorage.getItem("countryId");
      this.loadCountryDetail();
    } else {
      this.$router.push({ path: "/country/list" });
    }
  },
};
</script>

<style scoped>
.country-info-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  border-radius: 12px;
  margin-bottom: 24px;
}

.country-info-card .card-body {
  padding: 24px;
}

.country-header {
  display: flex;
  align-items: center;
  gap: 20px;
}

.country-flag-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 12px;
  overflow: hidden;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.country-flag-wrapper .flag-icon {
  font-size: 50px;
}

.country-details {
  flex: 1;
}

.country-name {
  color: white;
  font-size: 28px;
  font-weight: 600;
  margin: 0 0 8px 0;
}

.country-meta {
  display: flex;
  gap: 24px;
}

.meta-item {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
}

.meta-item strong {
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  margin-right: 4px;
}

.action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 24px;
  border-top: 1px solid #eee;
}

.action-buttons .btn {
  min-width: 120px;
  padding: 10px 24px;
}

.card .header h2 {
  margin-bottom: 4px;
}
</style>
